import React from 'react';
import { useSelector } from 'react-redux';

import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import LinkedAccountCell from 'components/ReactTable/CellRenderers/LinkedAccountCell';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from 'components/HomePage/GridColumnDefinitions/GetOptions';

const whsManagementUnpublishedColumnDefs = openLinkedAccountModal => [
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-account',
    filterIconId: 'filter-icon-account',
    filterTextFieldId: 'filter-text-field-account'
  },
  {
    Header: 'Is Active ?',
    accessor: 'accountIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-7p5',
    sortIconId: 'sort-account-active',
    filterIconId: 'filter-icon-account-active',
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-customer',
    filterIconId: 'filter-icon-customer',
    filterTextFieldId: 'filter-text-field-customer'
  },
  {
    Header: 'Is Active ?',
    accessor: 'customerIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-7p5',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'WHS Name',
    accessor: 'whsName',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-12p5'
  },
  {
    Header: 'WHS Type',
    accessor: 'statementType',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p5'
  },
  {
    Header: 'WHS Valid',
    accessor: 'isValid',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isValid'),
    className: 'col-7p5',
    sortIconId: 'sort-is-valid',
    filterIconId: 'filter-icon-is-valid',
  },
  {
    Header: 'Allocation',
    accessor: 'allocation',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p5'
  },
  {
    Header: 'Owners',
    accessor: 'numBeneficialOwners',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p5'
  },
  {
    Header: 'Linked Accounts',
    accessor: 'linkedAccounts',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<LinkedAccountCell dataKey="linkedAccounts" data={ original } openLinkedAccountModal={ openLinkedAccountModal } />);
    },
    disableFilters: true,
    disableSortBy: true,
    className: 'col-7p5'
  }
];

export default whsManagementUnpublishedColumnDefs;
